import ArtistRadio from './ArtistRadio';
import hydrate from 'widget/hydrate';
import { ComponentProps, ComponentType } from 'react';

hydrate<ComponentProps<ComponentType<any>>>(ArtistRadio);
